import React, { FC } from 'react';
import { Box } from '@mui/material';
import RegisterInForm from '../components/FormComponents/RegisterInForm';
// import CompanyLogin from '../components/LoginScreenComponents/CompanyLogin';

const RegisterIn: FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100%',
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <RegisterInForm />
        </Box>
      </Box>
    </Box>
  );
};

export default RegisterIn;
